export default [
    '$scope',
    'spFreeDigitals',
    function FreeDigitalsHeading($scope, spFreeDigitals) {
        var pendingDownloadData = spFreeDigitals.getPendingDownloadData();

        $scope.isTryingToDownloadAll = spFreeDigitals.isTryingToDownloadAll();
        $scope.isTryingToDownloadAlbum = spFreeDigitals.isTryingToDownloadAlbum();
        $scope.isTryingToDownloadPhoto = spFreeDigitals.isTryingToDownloadPhoto();
        $scope.isTryingToDownloadVideo = spFreeDigitals.isTryingToDownloadVideo();
        $scope.isTryingToDownloadSlideshow = spFreeDigitals.isTryingToDownloadSlideshow();

        if (pendingDownloadData) {
            $scope.albumName = pendingDownloadData.albumName;
        }
    }
];
